import { useState, useEffect } from 'react'
import { SectionHeading } from './SectionHeading'
import { Spinner } from '../../../components/Spinner'
import { GridCard } from '../../../components/GridCard'

export function RelatedPosts() {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    App.Request.get(`/car_contents/${App.State.carId}/related_posts.json`)
      .then(({ data, status }) => {
        if (status === 200) {
          setPosts(data.posts)
        } else {
          return null
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <>
      {loading && <Spinner />}

      {!loading && posts.length > 0 && (
        <div id="related-posts">
          <SectionHeading
            title={I18n.t('articles')}
            link={{
              url: '/blog',
              title: I18n.t('go_to_blog'),
            }}
          />
          <ul className="list-unstyled row post-list mt-3">
            {posts.map((post) => (
              <li
                className="col-md-6 col-lg-3 col-6 my-3 align-item-stretch"
                key={post.id}
              >
                <GridCard
                  openInNewTab={false}
                  key={`post-${post.id}`}
                  url={`/blog/${post.id}/${post.slug}`}
                  image={{ src: post.image, alt: post.title }}
                >
                  <div className="text-primary font-heading text-black">
                    {post.title}
                  </div>
                </GridCard>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
